
import type { Screenshot } from './types';

export const screenshots: Screenshot[] = [
  {
    title: "Add your Recipes",
    description: "Import your recipes, use AI suggestions or create your own meals",
    image: "/lovable-uploads/d7a3f787-d89f-40cc-9e14-b175fd8f39d1.png",
    alt: "Recipe import interface showing options to add recipes from various sources"
  },
  {
    title: "Recipe Collection",
    description: "Browse and search through your recipe library",
    image: "/lovable-uploads/865c523a-dcfd-44c6-91e1-4e9103bcd0c8.png", 
    alt: "Recipe collection showing search and filtering capabilities"
  },
  {
    title: "Simple meal planner",
    description: "Everyone can import their recipes or use AI suggestions",
    image: "/lovable-uploads/c3e8cb27-2531-43c6-9ba0-a411ed864992.png",
    alt: "Weekly meal planner interface showing planned meals for each day"
  },
  {
    title: "Smart shopping list",
    description: "Let forkast create and organize your grocery list for the whole week",
    image: "/lovable-uploads/b5edee5e-c640-42cf-8977-390b271e6422.png",
    alt: "Shopping list organized by categories with checkable items"
  },
  {
    title: "Wellness Insights", 
    description: "Weekly summary of your eating habits and tips on what to improve",
    image: "/lovable-uploads/a8e7da91-c3de-4e08-b6a0-271cdc1ad00e.png",
    alt: "Wellness dashboard showing nutritional insights and meal categories"
  },
  {
    title: "Family Activity",
    description: "Keep up with the weekly planning activity via the feed or notifications",
    image: "/lovable-uploads/20f640df-d987-46f8-bc58-fef52465ffdc.png",
    alt: "Family activity feed showing meal planning updates and collaboration"
  }
];
